export default "__VITE_ASSET__Ci3QqsLR__"